/* eslint-disable */
export default {
  contactDetails: 'Coordonnées',
  loadingContact: 'Chargement des contacts…',
  contactNotFound: 'Contact introuvable.',
} as const;

// @key: @#@"contactDetails"@#@ @source: @#@"Contact Details"@#@
// @key: @#@"loadingContact"@#@ @source: @#@"Loading contact..."@#@
// @key: @#@"contactNotFound"@#@ @source: @#@"Contact not found."@#@
